import React from 'react'
import Button from '@components/Button'
import InfoIcon from '@components/Icon/Info'
import InfoBox from '@components/InfoBox'


import LogInCt from './LoginCt'

export default function LoggedOut() {
  const login = ()=>{
    window.location.pathname = ''
  }

  return (
   <LogInCt>
     <>
        <div style={{margin: 16}}>
          <Button primary block onClick={login}>
            Log in
          </Button>
        </div>
        <InfoBox theme={"blue"} icon={<InfoIcon />} >
        You have been successfully logged out.
        </InfoBox>
      </>
    </LogInCt>
  );
}
